import React from 'react';

import OnboardingLayout from '../../layouts/onboarding/onboarding';
import { i18n } from '../../utils';

import infoError from './info-error.png';
import styles from './page-error.scss';

class PageError extends React.Component {
  public render() {
    return (
      <OnboardingLayout>
        <div className={styles.page}>
          <img src={infoError} width="200" height="200" />
          {i18n.t('page.error.title')}
        </div>
      </OnboardingLayout>
    );
  }
}

export default PageError;
